export const dateConfig = {
    weeks: { 
        1: 'ПН', 
        2: 'ВТ', 
        3: 'СР', 
        4: 'ЧТ', 
        5: 'ПТ', 
        6: 'СБ', 
        0: 'ВС' 
      },
      months: {
        1: 'Январь', 
        2: 'Февраль', 
        3: 'Март', 
        4: 'Апрель', 
        5: 'Май', 
        6: 'Июнь',
        7: 'Июль', 
        8: 'Август', 
        9: 'Сентябрь', 
        10: 'Октябрь', 
        11: 'Ноябрь', 
        12: 'Декабрь'
    }
}